import { cx } from '@onbeam/business-styled-system/css';
import { flex } from '@onbeam/business-styled-system/patterns';
import { PropsWithChildren } from 'react';

export const MenuItem = ({
  children,
  href,
  isExternal,
  className,
}: PropsWithChildren<{
  href?: string;
  className?: string;
  isExternal?: boolean;
}>) => {
  const Component = href ? 'a' : 'div';

  return (
    <Component
      className={cx(
        flex({
          px: '4',
          py: '2.5',
          rounded: 'xs',
          transition: 'colors',
          cursor: 'pointer',
          textStyle: 'body-sm',
          _hoverFocus: {
            bg: 'mono.quartenery',
          },
        }),
        className,
      )}
      {...(href && {
        href,
        ...(isExternal && { target: '_blank', rel: 'noopener noreferrer' }),
      })}
    >
      {children}
    </Component>
  );
};
